import React, {Component} from 'react'
import {Control, Errors} from 'react-redux-form'
import {FormGroup, ControlLabel} from 'react-bootstrap'
import {actions} from 'react-redux-form'
import DateTime from 'react-datetime'
import PropTypes from 'prop-types';
import store from '../../../../store'
import {validators} from "../../../../utils/validators"

import 'react-datetime/css/react-datetime.css'

class DateOfBirthSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  handleChange = (model, value) => {
    if (typeof value === 'object') {
      store.dispatch(actions.change(model, value.format('DD/MM/YYYY')));
    } else {
      store.dispatch(actions.change(model, ''));
    }
    store.dispatch(actions.resetValidity(model));
    this.setState({open: false});
  };

  render() {
    const {model} = this.props;

    return (
      <FormGroup controlId="dateOfBirth" validationState={this.state.date_of_birth} className="ignite-datepicker">
        <ControlLabel>Date of Birth* (DD/MM/YYYY)</ControlLabel>
        <Control.text model={model}
                      validators={{required: validators.required(this.updateErrors, 'date_of_birth')}}
                      controlProps={{
                        timeFormat: false,
                        dateFormat: "DD/MM/YYYY",
                        open:       this.state.open,
                        onFocus:    () => this.setState({open: true}),
                        onBlur:     () => this.setState({open: false}),
                        inputProps: {
                          "disabled": !!this.props.disabled
                        }
                      }}
                      changeAction={this.handleChange}
                      component={DateTime}/>

        <Errors show={{touched: true}}
                className="errors"
                model={model}
                messages={{required: 'This field is required'}}/>

      </FormGroup>
    )
  }
}

DateOfBirthSelector.propTypes = {
  model: PropTypes.string,
};

DateOfBirthSelector.defaultProps = {
  model: '.date_of_birth',
};

export default DateOfBirthSelector


// WEBPACK FOOTER //
// ./src/components/common/form/user/date-of-birth-selector.jsx